
























import Vue from 'vue'
import LoginWrapper from '@/components/LoginWrapper'
import { required, minLength } from 'vuelidate/lib/validators'
import fb from '../../firebase'
import './RecoverEmail.scss'

export default Vue.extend({
  name: 'RecoverEmail',
  created () {
    // @ts-ignore
    if (window.chrome) {
      const urlParams = new URLSearchParams(window.location.search)
      this.actionCode = urlParams.get('oobCode') || ''
      this.mode = urlParams.get('mode') || ''
      this.apiKey = urlParams.get('apiKey') || ''
      if (this.actionCode !== '') {
        this.verifyEmail()
      }
    }
  },
  data: () => ({
    password: '',
    actionCode: '',
    submitStatus: '',
    mode: '',
    apiKey: '',
    lang: '',
    showForm: false,
    accountEmail: ''
  }),
  methods: {
    verifyEmail () {
      fb.firebase.auth().verifyPasswordResetCode(this.actionCode).then(email => {
        this.accountEmail = email
        this.showForm = true
      }).catch(error => {
        console.log(error)
        // Invalid or expired action code. Ask user to try to reset the password
        // again.
      })
    },
    formSubmitted () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        fb.firebase.auth().confirmPasswordReset(this.actionCode, this.password).then(resp => {
          console.log(resp)
          // Password reset has been confirmed and new password updated.
          // send them back to login
          this.$router.push({ path: '/login' })
          //
        }).catch(() => {
          // console.log(error)
          // Error occurred during confirmation. The code might have expired or the
          // password is too weak.
        })
      }
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(6)
    }
  },
  components: {
    LoginWrapper
  }
})
